import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { MatDividerModule } from '@angular/material/divider';
import { MatDialogModule } from '@angular/material/dialog';
import { MeteringResourcesDialogComponent } from './metering-resources-dialog.component';
import { IconsModule } from 'src/app/icons/icons.module';
import * as echarts from 'echarts';
import { NgxEchartsModule } from 'ngx-echarts';

@NgModule({
  declarations: [MeteringResourcesDialogComponent],
  imports: [
    CommonModule,
    SharedModule,
    IconsModule,
    MatDividerModule,
    MatDialogModule,
    NgxEchartsModule.forRoot({
      echarts
    })
  ],
  exports: [
    MeteringResourcesDialogComponent
  ]
})
export class MeteringResourcesDialogModule { }
